import { h } from 'preact';
import { Skeleton } from './Skeleton';
import styles from '../../pages/Pages.module.scss';
export function SearchResultsHeaderSkeleton() {
    return (h("div", { class: styles.searchResultsHeader },
        h(Skeleton, { width: "300px", height: "38px", borderRadius: "4px" })));
}
